import { gql, QueryHookOptions, useQuery } from '@apollo/client'

import { useAuth } from '@features/auth'

export type CouponInfo = {
  id: string
  code: string
  qrCode?: string | null
  name: string
  status: number
  validFrom: string
  validTo: string
  localInfo?: {
    id: string
    title: string
    shortDescription?: string
    description?: string
    imageUrl?: string
    image?: {
      url: string
    }
    validFrom: string
    validTo: number
    canBeActivated: boolean
  }
}

type CustomerCouponsQuery = {
  customerCoupons: CouponInfo[]
}

export const GQL_CUSTOMER_COUPONS = gql`
  query CustomerCoupons {
    customerCoupons {
      id
      code
      qrCode
      name
      status
      validFrom
      validTo
      localInfo {
        id
        title
        shortDescription
        description
        imageUrl
        image {
          url
        }
        validFrom
        validTo
        canBeActivated
      }
    }
  }
`

export function useFetchCustomerCoupons (options: QueryHookOptions = {}) {
  const { isAuthorized, requireRegistration } = useAuth()
  
  const { data, loading, error, refetch } = useQuery<CustomerCouponsQuery>(
    GQL_CUSTOMER_COUPONS,
    { 
      ...options,
      skip: !isAuthorized || requireRegistration || options.skip
    }
  )

  return {
    data,
    coupons: data?.customerCoupons || [],
    loading,
    error,
    refetch
  }
}